module.exports = __webpack_public_path__ + "img/weibo.587f5c8.svg";